import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
const themingColors = [
  'background',
  'foreground',
  'primary',
  'secondary',
  'destructive',
  'muted',
  'popover',
  'tooltip',
  'card',
  'sidebar',
  'chart',
  'brand',
  'danger',
  'accent',
  'success',
  'warning',
  'info',
  'lightBackground',
] as const

export const baseColors = [
  'grass',
  'amber',
  'blue',
  'yellow',
  'red',
  'indigo',
  'iris',
  'gray',
  'purple',
  'orange',
  'tomato',
  'violet',
  'pink',
  'ruby',
  'teal',
  'lime',
  'emerald',
  'cyan',
  'sky',
  'crimson',
  'jade',
  'plum',
  'green',
  'brown',
] as const

export const colors = [...themingColors, ...baseColors] as const

export type Color = (typeof colors)[number]

export const hashIdToColor = (id: string, colors: readonly Color[] = baseColors): Color => {
  const hashNumber = id.split('').reduce((acc, char) => {
    return acc + char.charCodeAt(0)
  }, 0)
  return colors[hashNumber % colors.length] ?? 'gray'
}
